const toPln = (value: any) => (`${Number(value).toLocaleString('pl-PL', {
    maximumFractionDigits: 0,
    // style: 'currency',
    // currency: 'PLN',
})}`);

const nFormatter = (num: number) => {
    if (num >= 1000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (num >= 1000) {
        return toPln((num / 1000)).replace(/\.0$/, '') + 'K';
    }
    return num;
}

export {toPln, nFormatter}